// src/components/shared/FormSelect.jsx
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from '@mui/material';

const FormSelect = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  options,
  error,
  helperText,
  disabled = false,
  required = false,
  size = "medium",
  fullWidth = true,
  defaultOption = "-- Seleccione --",
  showDefaultOption = true,
  ...props
}) => {
  const labelId = `${name}-label`;
  
  return (
    <FormControl 
      fullWidth={fullWidth} 
      error={!!error} 
      required={required}
      size={size}
      {...props}
    >
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        id={name}
        name={name}
        value={value}
        label={label}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      >
        {showDefaultOption && (
          <MenuItem value="">{defaultOption}</MenuItem>
        )}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value.toString()}>
            {option.label || option.value}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default FormSelect;